import { Editor } from 'slate';
import { getBlockAbove } from './get-block-above';
import { isStart } from './is-start';

export function isBlockStart(editor: Editor, options?: Parameters<typeof getBlockAbove>[1]) {
    const path = getBlockAbove(editor, options)?.[1];

    return !!path && isStart(editor, path);
}
